import React, { Component } from 'react'
import { Switch } from 'react-router-dom';

import RecepcionFiles from './files/RecepcionFiles';
import GuardianRoute from '../../shared/GuardianRoute';
import RecepcionUpload from './files/upload/RecepcionUpload';
import RecepcionFilesInfo from './files/info/RecepcionFilesInfo';

class Recepcion extends Component {

  render() {
    return (
      <>
        <Switch>
          <GuardianRoute path="/modulos/recepcion"
            component={ RecepcionFiles }
            can="recepcion.listar"
            exact
          />
          <GuardianRoute path="/modulos/recepcion/:id/info"
            component={ RecepcionFilesInfo }
            can="recepcion.info"
            exact
          />
          <GuardianRoute path="/modulos/recepcion/upload"
            component={ RecepcionUpload }
            can="recepcion.subir.archivo"
            exact
          />
        </Switch>
      </>
    )
  }
}

export default Recepcion;